import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "Bilbao/bilbao_7",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_3",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_4",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Bilbao/bilbao_5",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_6",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_18",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_10",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_19",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_8",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_15",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_9",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_1",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_13",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_21",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_20",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_17",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_11",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_14",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_2",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_12",
	    "orientation": "portrait"
	  },
	  {
	    "src": "Bilbao/bilbao_16",
	    "orientation": "portrait"
	  }
	]
}

export default class Berlin extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Bilbao" 
			text="23.11 - 26.11.18" 
			images={projectElements.images} 
			layout={'zweier'}/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/bilbao.js